<template>
  <div class="search">
    <div class="search-history">
      <div class="search-container">
        <input :maxlength="20" v-model.trim="resourceName" placeholder="请输入名称搜索" type="text" />
        <van-icon @click="handleSearch" name="search" />
      </div>
      <template v-if="!show">
        <div class="title">
          <span>最近搜索</span>
          <span @click="handleClear">清空</span>
        </div>
        <div class="history-container">
          <div @click="searchByHistory(item)" class="item" v-for="item in history" :key="item">{{ item }}</div>
        </div>
      </template>
      <template v-else>
        <main v-if="searchList.length">
          <div @click="handle2Active(item)" class="search-box" v-for="item in searchList" :key="item.id">
            <img :src="$isCdn(item.pic)" alt="" />
            <div class="info">
              <div class="info-title van-ellipsis">{{ item.name }}</div>
              <div class="basic">
                <span>{{ item.userName }}</span>
                <span>{{ item.createTime | formatDate('yyyy-MM-dd') }}</span>
                <span>{{ item.visitCount }}观看</span>
              </div>
            </div>
          </div>
        </main>
        <van-empty v-else description="暂无搜索内容"></van-empty>
      </template>
    </div>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getFindInfo} from '@/api'
export default {
  data() {
    return {
      resourceName: '',
      history: [],
      searchList: [],
      show: false,
      pageNo: 1,
      pageSize: 20,
      total: null
    }
  },
  created() {
    const historyStr = localStorage.getItem('history') || '[]'
    this.history = JSON.parse(historyStr)
  },
  methods: {
    handle2Active({id, type}) {
      if (type === '3') {
        this.$router.push(`/play/${id}`)
      }
      if (type === '2') {
        this.$router.push(`/play/${id}`)
      }
      if (type === '1') {
        this.$router.push(`/resourcePlay/${id}`)
      }
    },
    handleClear() {
      this.history = []
      localStorage.removeItem('history')
    },
    searchByHistory(item) {
      this.resourceName = item
      this.findBySearch()
    },
    handleSearch() {
      if (!this.resourceName) {
        this.$Toast.fail('搜索不能为空')
        return false
      }
      this.findBySearch()
    },
    findBySearch() {
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        resourceName: this.resourceName,
        stageId: -1,
        gradeId: -1,
        subjectId: -1,
        versionId: -1,
        catalogId: -1,
        lableId: -1,
        resourceFamily: 0,
        orderType: 1
      }
      this.history.push(this.resourceName)
      this.history = Array.from(new Set(this.history))
      localStorage.setItem('history', JSON.stringify(this.history))
      getFindInfo(params).then(res => {
        if (res.code === 0) {
          this.searchList = [...this.searchList, ...res.data]
          this.show = true
          this.total = Math.ceil(Number(res.totalDatas) / this.pageSize)
          this.pageNo += 1
        }
      })
    },
    getScroll() {
      return {
        left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
        top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      }
    },
    handleScroll() {
      const body = document.documentElement || document.body
      const scrollTop = this.getScroll().top
      const scrollHeight = body.scrollHeight
      const clientHeight = body.clientHeight
      if (scrollTop + clientHeight >= scrollHeight - 30) {
        if (this.pageNo > this.total) {
          return
        }
        this.findBySearch()
      }
    }
  },
  mounted() {
    document.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
.search {
  min-height: 100vh;
  background: linear-gradient(#ffffff, #f4f6f9);
}

.search-history {
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    margin-bottom: 10px;
    padding: 0 16px;
    span {
      color: #303133;
      &:nth-child(1) {
        font-weight: 700;
      }
    }
  }
}
.history-container {
  padding: 0 16px;
  div {
    background: #f4f6f9;
    border: 1px solid #e5e8ec;
    display: inline-block;
    margin: 0 10px 10px 0;
    padding: 4px 10px;
    font-size: 14px;
    border-radius: 20px;
    color: #303133;
  }
}
.search-container {
  position: relative;
  margin-bottom: 10px;

  padding: 12px 16px;
  input {
    background: #f4f6f9;
    border: none;
    outline: none;
    width: 100%;
    padding: 10px 40px 10px 20px;
    border-radius: 18px;
  }
  input::-webkit-input-placeholder {
    color: #c0c4cc;
    font-size: 14px;
  }
  i {
    position: absolute;
    right: 22px;
    top: 50%;
    font-size: 20px;
    transform: translateY(-50%);
  }
}
main {
  padding: 0 16px 16px;
}
.search-box {
  background: #fff;
  padding: 16px 14px;
  display: flex;
  box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.1);
  margin-top: 16px;
  border-radius: 12px;
  img {
    height: 74px;
    width: 120px;
    border-radius: 6px;
    margin-right: 17px;
  }
  .info {
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .info-title {
      word-break: break-all;
    }
    .basic {
      color: #909399;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
